import { ChangeDetectionStrategy, Component, computed, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { AdHocContractParams } from '@scripts/woo_services.module/AdHocContractService';
import { AdOrganisation, CompactAgency } from '@scripts/woo_services.module/shared-types';
import { BaseModalComponent } from '@src/shared/modal/base-modal/base-modal.component';
import { ModalLayoutComponent } from '@src/shared/modal/base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-new-adhoc-discount-modal',
  imports: [ModalLayoutComponent, WooComponentsModule, FormsModule],
  templateUrl: './new-adhoc-discount-modal.component.html',
  styleUrl: './new-adhoc-discount-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewAdHocDiscountModalComponent extends BaseModalComponent<{
  agencies: CompactAgency[];
  adOrganisations: AdOrganisation[];
}> {
  submit = output<AdHocContractParams>();
  readonly agencies = computed(() => this.modaldata()?.agencies ?? []);
  readonly adOrganisations = computed(() => this.modaldata()?.adOrganisations ?? []);
}
